<template>
    <div v-show="visible">
        <label>
            {{ t(displayName) }}
        </label>
        <dateRange-picker-pl
            style="width: 100%; min-width: 100%;"
            @update="onUpdate"
            v-model="value"
            :min-date="minDate"
            :max-date="maxDate"
            >
            <div slot="input picker" v-if="isValueSet">
                {{ value.startDate }} - {{ value.endDate }}
            </div>
            <div slot="input picker" v-else>{{ t('Select dates') }}</div>
        </dateRange-picker-pl>
    </div>
</template>

<script>

import DateRangePickerPl from "@/components/DateRangePickerPl.vue";
import moment from "moment";
import {FILTER_DATE_FORMAT} from "@/const";
import DateFormatter from "@/Models/DateFormatter.ts";

export default {
    components: {DateRangePickerPl},
    props: {
        config: {
            type: Object,
            default: () => {
                return {
                    name: null,
                    group: false,
                    value: {
                        startDate: null,
                        endDate: null,
                    },
                    loadUrl: null,
                    display: true,
                    position: 0,
                    isMultiple: null,
                    displayName: null
                };
            }
        },
        eventBus: {
            Type: Object,
        },
        queryParams: {
            Type: Object
        },
        routeParams: {
            Type: Object
        },
        onChange: {
            Type: Function,
        },
        onDefaultValueSet: {
            Type: Function,
        },
    },
    data() {
        return {
            displayName: null,
            visible: true,
            value: {
                startDate: null,
                endDate: null,
            },
            minDate: null,
            maxDate: null,
            name: null,
        };
    },
    mounted() {
        this.init();
        this.$parent.$on(`${this.name}-set-value`, (filterState) => {
            this.setValue(filterState);
        });
        this.setDefaultValue(this.queryParams[this.name] || this.config.value);
    },
    computed: {
        isValueSet() {
            return this.value !== null;
        }
    },
    methods: {
        onUpdate() {
            let value= {};

            if (this.value.startDate) {
                value.startDate = moment(this.value.startDate).format(FILTER_DATE_FORMAT);
            }
            if (this.value.endDate) {
                value.endDate = moment(this.value.endDate).format(FILTER_DATE_FORMAT);
            }

            this.onChange(this.name, value);
        },
        init() {
            this.displayName = this.config.displayName;
            this.visible = this.config.visible;
            this.minDate = this.config.minDate;
            this.maxDate = this.config.maxDate;
            this.name = this.config.name;
        },
        setDefaultValue(value) {
            this.setValue(value);
            this.onDefaultValueSet(this.name, this.value);
        },
        setValue(value) {
            let dateFormatter = new DateFormatter();
            this.value = dateFormatter.format(value);
        }
    }
}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// DateRangeComponent.vue?633f923e